import { React, useEffect } from "react";
import "./style.css";
import { Container } from "components";


function TermsAndConditions() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className="relative w-full h-full py-[100px] laptop:py-[150px] terms-conditions">
      <div className="relative max-w-[1140px] mx-auto px-4">
        <h1 className="text-[30px] md:text-[45px] laptop:text-[56px] font-medium leading-none laptop:leading-[56px] tracking-tighter laptop:-tracking-[1px] text-white">
          Launchpool Terms and Conditions
        </h1>
        <h2>1. Introduction</h2>
        <p>These Terms and Conditions (“Terms”) form a legally binding agreement between you (“User” or “You”) and Vanry Technology DMCC (“Vanar Launchpool” or “We”). By accessing, using, or participating in the Vanar Launchpool on the Vanar Blockchain, you agree to these Terms.</p>
        <h2>2. Definitions</h2>
        <ul>
          <li><strong>Vanar Launchpool: </strong> Platform for staking/farming $VANRY and other accepted tokens to support projects on Vanar Blockchain.</li>
          <span className="mt-16"></span>
          <li><strong>Vanar: </strong> The blockchain supporting the Vanar Launchpool.</li>
          <span className="mt-16"></span>
          <li><strong>$VANRY: </strong> The native token of the Vanar Blockchain.</li>
          <span className="mt-16"></span>
          <li><strong>VAULTS: </strong> Specific pools where users can stake tokens.</li>
          <span className="mt-16"></span>
          <li><strong>Token Generation Event (TGE): </strong> Event marking the creation and distribution of new tokens.</li>
          <span className="mt-16"></span>
        </ul>
        <h2>3. General Provisions</h2>
        <ul>
          <li><strong>Contractual Relationship:  </strong> These Terms form a legally binding agreement under the laws of Dubai, UAE.
          </li>
          <span className="mt-16"></span>
          <li><strong> Revisions and Amendments:
          </strong> Vanar Launchpool reserves the right to revise these Terms at any time. Continued use of the platform constitutes acceptance of such changes.
          </li>
          <span className="mt-16"></span>
          <li><strong>Privacy Policy:  </strong> By using Vanar Launchpool, you agree to our Privacy Policy.
          </li>
          <span className="mt-16"></span>
          <li><strong> Use of Platform:  </strong> Users must comply with all applicable laws and must not misuse the platform.
          </li>
          <span className="mt-16"></span>
        </ul>
        <h2>4. Intellectual Property</h2>
        <p>All content and materials on Vanar Launchpool are owned by Vanry Technology DMCC. Users retain ownership of data they upload but grant Vanar a license to use this data.</p>
        <h2>5. Registration and Requirements</h2>
        <ul>
          <li><strong>Wallet Use: </strong> Users do not need a username or account as access is through their blockchain wallet. </li>
          <span className="mt-16"></span>
          <li><strong>Eligibility:</strong> Users must be at least 18 years old and not from prohibited jurisdictions.          </li>
          <span className="mt-16"></span>
          <li><strong>Identity Verification:</strong>  If required, for compliance with KYC/AML/CFT regulations (if needed or requested by the projects).</li>
          <span className="mt-16"></span>
          <li><strong>Account Security:</strong> Users are responsible for maintaining the security of their wallet credentials.
          </li>
          <span className="mt-16"></span>
        </ul>
        <h2>6. Launchpool Services</h2>
        <ul>
          <li><strong>Staking and Farming: </strong> Users can stake $VANRY and other accepted tokens in VAULTS for rewards.          </li>
          <span className="mt-16"></span>
          <li><strong>Flexibility and Penalties: </strong>Early unstaking is allowed but results in forfeiture of airdrop eligibility and a 2.5% penalty.
          </li>
          <span className="mt-16"></span>
        </ul>
        <h2>7. Representations and Warranties</h2>
        <p>Users represent and warrant that their use of Vanar Launchpool will not involve any illegal activities and that they are responsible for compliance with tax regulations.</p>
        <h2>8. Networks and Tokens</h2>
        <p>Vanar Launchpool may not support all networks or assets. Decisions on support will be made at Vanar’s discretion.</p>
        <h2>9. Risk Disclosure</h2>
        <p>Users acknowledge the risks associated with digital assets, including volatility, regulatory changes, and technical failures. Vanar Launchpool is provided “as is” without warranties of any kind. If a user’s wallet gets hacked or they lose access to it, Vanar is not responsible for changing or editing the user’s address.</p>
        <h2>10. Limitation of Liability</h2>
        <p className="mb-16">To the fullest extent permitted by law, Vanry Technology DMCC and Vanar Launchpool, including its affiliates, officers, directors, employees, and agents, shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses, resulting from:</p>
        <ul>
          <li>Your access to or use of or inability to access or use the Launchpool;
          </li>
          <span className="mt-16"></span>
          <li>Any conduct or content of any third party on the Launchpool;
          </li>
          <span className="mt-16"></span>
          <li>Any unauthorized access, use, or alteration of your transmissions or content;
          </li>
          <span className="mt-16"></span>
          <li>Any errors, mistakes, or inaccuracies of content;
          </li>
          <span className="mt-16"></span>
          <li>Any interruption or cessation of transmission to or from the Launchpool;
          </li>
          <span className="mt-16"></span>
          <li>Any errors or omissions in any content or for any loss or damage incurred as a result of the use of any content posted, emailed, transmitted, or otherwise made available via the Launchpool.</li>
          <span className="mt-16"></span>
        </ul>
        <p className="mb-16"> Vanar Launchpool is not liable for any indirect or consequential damages. Liability is limited to the gas fees paid by the user in the preceding 12 months.        </p>
        <p className="mb-16">Vanry Technology DMCC makes no warranties or representations about the accuracy or completeness of the Launchpool content or the content of any sites linked to the Launchpool and assumes no liability or responsibility for any:</p>
        <ul>
          <li>Errors, mistakes, or inaccuracies of content;
          </li>
          <span className="mt-16"></span>
          <li>Personal injury or property damage, of any nature whatsoever, resulting from your access to and use of the Launchpool;
          </li>
          <span className="mt-16"></span>
          <li>Any unauthorized access to or use of our secure servers and/or any and all personal information stored therein;
          </li>
          <span className="mt-16"></span>
          <li>Any interruption or cessation of transmission to or from the Launchpool;
          </li>
          <span className="mt-16"></span>
          <li>Any errors or omissions in any content or for any loss or damage of any kind incurred as a result of the use of any content posted, emailed, transmitted, or otherwise made available via the Launchpool.</li>
          <span className="mt-16"></span>
        </ul>
        <h2>11. Indemnification</h2>
        <p>Users agree to indemnify and hold harmless Vanar Launchpool and Vanry Technology DMCC, its affiliates, and their respective officers, directors, employees, and agents, from and against any claims, liabilities, damages, losses, and expenses, including, without limitation, reasonable legal and accounting fees, arising out of or in any way connected with your access to or use of the Launchpool or your violation of these Terms.</p>
        <h2>12. Notices</h2>
        <p>Notices will be sent to the user’s last known contact information or posted on the Vanar Launchpool website.</p>
        <h2>13. Governing Law and Dispute Resolution</h2>
        <p>These Terms shall be governed by and construed in accordance with the laws of Dubai, UAE, without regard to its conflict of law principles. Disputes will be resolved through arbitration in Dubai, under UAE law. Class action waivers apply.
        </p>
        <h2>14. Miscellaneous</h2>
        <ul>
          <li><strong>Severability:</strong> Invalid provisions do not affect the validity of the remaining Terms.
          </li>
          <span className="mt-16"></span>
          <li><strong>Assignment: </strong> Vanar Launchpool can assign its rights without notice.
          </li>
          <span className="mt-16"></span>
          <li><strong>Entire Agreement:</strong> These Terms constitute the entire agreement between the parties.
          </li>
          <span className="mt-16"></span>
        </ul>
      </div>
    </div>
  );
}

export default TermsAndConditions;
